import { render, staticRenderFns } from "./home.vue?vue&type=template&id=224ffcea&scoped=true"
import script from "./home.vue?vue&type=script&lang=js"
export * from "./home.vue?vue&type=script&lang=js"
import style0 from "./home.vue?vue&type=style&index=0&id=224ffcea&prod&scoped=true&lang=less"
import style1 from "./home.vue?vue&type=style&index=1&id=224ffcea&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "224ffcea",
  null
  
)

export default component.exports